import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white py-2">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center gap-4 text-sm">
          {/* 安全保障標語 */}
          <div className="hidden md:flex items-center gap-1.5 text-white/90 font-medium">
            <i className="ri-shield-check-fill text-green-300 text-base"></i>
            <span>SSL 全程加密・帳密閱後即焚・0 鎖號保證</span>
          </div>
          <div className="flex items-center gap-4 ml-auto">
            <a 
              href="https://line.me/R/ti/p/@laigame" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity whitespace-nowrap"
            >
              <i className="ri-line-fill text-lg"></i>
              <span>客服帳號</span>
            </a>
            <a 
              href="https://www.facebook.com/laigame" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity whitespace-nowrap"
            >
              <i className="ri-facebook-fill text-lg"></i>
              <span>粉絲專頁</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-6">
          {/* Logo — 點擊回首頁 */}
          <Link to="/" className="flex-shrink-0 group">
            <img 
              src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/85b2a998400146a99430a443824c5c33.jpeg" 
              alt="laigame手遊代儲"
              className="h-12 w-auto object-contain transform group-hover:scale-105 transition-transform"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-5 flex-1 justify-center">
            <Link to="/games" className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap font-medium">
              專業手遊代儲
            </Link>
            <Link to="/order" className="px-3 py-1.5 bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white rounded-full text-sm font-bold hover:shadow-md transition-all whitespace-nowrap flex items-center gap-1.5">
              <i className="ri-gamepad-fill"></i>
              立即下單
            </Link>
            <Link to="/agent" className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap font-medium">
              代理回饋制度
            </Link>
            <Link to="/vip" className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap font-medium">
              VIP新制度
            </Link>
            <Link to="/faq" className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap font-medium">
              購物 Q&amp;A
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap font-medium">
              聯絡我們
            </Link>
          </nav>

          {/* Right Actions */}
          <div className="flex items-center gap-4">
            {/* Search */}
            <button 
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              className="text-gray-600 hover:text-[#2563eb] transition-colors cursor-pointer"
              aria-label="搜尋"
            >
              <i className="ri-search-line text-xl"></i>
            </button>

            {/* Account */}
            <Link 
              to="/account" 
              className="hidden md:flex text-gray-600 hover:text-[#2563eb] transition-colors"
              aria-label="帳戶"
            >
              <i className="ri-user-line text-xl"></i>
            </Link>

            {/* Cart */}
            <Link 
              to="/cart" 
              className="relative text-gray-600 hover:text-[#2563eb] transition-colors"
              aria-label="購物車"
            >
              <i className="ri-shopping-cart-line text-xl"></i>
              <span className="absolute -top-2 -right-2 bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                0
              </span>
            </Link>

            {/* Mobile Menu Toggle */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden text-gray-600 hover:text-[#2563eb] transition-colors cursor-pointer"
              aria-label="選單"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Search Bar */}
        {isSearchOpen && (
          <div className="mt-4 animate-fadeIn">
            <form className="flex gap-2">
              <input 
                type="search" 
                placeholder="全站搜尋 .." 
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#2563eb] text-sm"
              />
              <button 
                type="submit"
                className="px-6 py-2 bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white rounded-lg hover:shadow-lg transition-all whitespace-nowrap"
              >
                搜尋
              </button>
            </form>
          </div>
        )}

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t pt-4 animate-fadeIn">
            <div className="flex flex-col gap-3">
              <Link to="/games" className="text-gray-700 hover:text-[#2563eb] transition-colors py-2">
                專業手遊代儲
              </Link>
              <Link to="/order" className="flex items-center gap-2 py-2 text-[#2563eb] font-bold">
                <i className="ri-gamepad-fill"></i>
                立即下單（代儲服務）
              </Link>
              <Link to="/agent" className="text-gray-700 hover:text-[#2563eb] transition-colors py-2">
                代理回饋制度
              </Link>
              <Link to="/vip" className="text-gray-700 hover:text-[#2563eb] transition-colors py-2">
                VIP新制度
              </Link>
              <Link to="/faq" className="text-gray-700 hover:text-[#2563eb] transition-colors py-2">
                購物 Q&amp;A
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-[#2563eb] transition-colors py-2">
                聯絡我們
              </Link>
              <Link to="/account" className="text-gray-700 hover:text-[#2563eb] transition-colors py-2 md:hidden">
                會員中心
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}